import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import Home from './pages/Home'
import About from './pages/About'

function App() {
  return (
    <Router>
      <div className="min-h-screen flex flex-col bg-gray-50" data-component-path="client/src/App.jsx" data-component-line="10:5" data-component-id="client/src/App.jsx:10:5">
        <Navbar />
        <main className="flex-grow" data-component-path="client/src/App.jsx" data-component-line="12:9" data-component-id="client/src/App.jsx:12:9">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
          </Routes>
        </main>
        <Footer />
        <Toaster position="top-right" />
      </div>
    </Router>
  )
}

export default App